import PropTypes from "prop-types";
import Tooltip from "@shared/v2/Tooltip";
import { calculateCallsTotals, secondsToHMS, truncateTime } from "./reportHelpers";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const TableData = ({ truncateTime: truncate, value }) => (
  <TD>
    {truncate ? (
      <Tooltip placement="right" trigger={<strong>{truncateTime(value)}</strong>} content={value} />
    ) : (
      <strong>{value}</strong>
    )}
  </TD>
);

TableData.propTypes = {
  truncateTime: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

TableData.defaultProps = {
  truncateTime: false,
};

const AgentCallsTotalRow = ({ reportData }) => (
  <TR className="tw-sticky tw-bottom-0 tw-bg-white">
    <TableData value="Totals" />
    <TableData value={calculateCallsTotals(reportData, "call_report_agent_total_lead_count")} />
    <TableData value={calculateCallsTotals(reportData, "call_report_lead_call_count")} />
    <TableData value={calculateCallsTotals(reportData, "call_report_manual_calls")} />
    <TableData value={calculateCallsTotals(reportData, "call_report_dialer_calls")} />
    <TableData value={calculateCallsTotals(reportData, "call_report_total_calls")} />
    <TableData
      value={secondsToHMS(calculateCallsTotals(reportData, "call_report_total_dialer_call_time_seconds"))}
      truncateTime
    />
  </TR>
);

AgentCallsTotalRow.propTypes = {
  reportData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default AgentCallsTotalRow;
